import $ from "jquery";
import {sendEvent} from "./ga";

let widgetId = null;

window.gRecaptchaCallback = function (token) {
    const button = window.lastClickedButton;
    if (!button) return;

    const form = button.closest('form');
    if (!form) return;

    processFormSubmit($(form), token);

    // сбросить капчу для повторного использования
    grecaptcha.reset(widgetId);
};

function processFormSubmit(form, token) {
    form.removeClass('_success');
    form.find('.form-group').removeClass('_error');
    form.find('.custom-error').hide();

    $.ajax({
        url: form.attr('action'),
        method: 'POST',
        data: form.serialize() + `&g-recaptcha-response=${encodeURIComponent(token)}`,
        success: function (response) {
            if (response.success) {
                debugger
                form.addClass('_success');
                sendEvent('key_form', {})
                setTimeout(function () {
                    form.removeClass('_success');
                    form[0].reset();
                }, 5000)
            } else {
                alert('Произошла неизвестная ошибка. Пожалуйста, повторите попытку.');
            }
        },
        error: function (xhr) {
            if (xhr.status === 422) {
                let errors = xhr.responseJSON.errors;
                $.each(errors, function (key, rules) {
                    let errorMessage = '';
                    $.each(Object.values(rules), function (rule, message) {
                        if (typeof message === 'object') {
                            $.each(Object.values(message), function (r, m) {
                                errorMessage += m + '<br>';
                            });
                        } else {
                            errorMessage += message + '<br>';
                        }
                    });
                    form.find('.form-group__error.' + key).html(errorMessage);
                    form.find('.form-group__error.' + key).closest('.form-group').addClass('_error');
                    form.find('.custom-error.' + key).html(errorMessage).show();
                });
            } else {
                alert('Произошла неизвестная ошибка. Пожалуйста, повторите попытку.');
            }
        },
    });
}

$(document).ready(function () {
    // сохранить активную кнопку
    $('button.g-recaptcha').on('click', function () {
        window.lastClickedButton = this;
        grecaptcha.execute(widgetId);
    });
});

// после загрузки капчи инициализировать невидимый виджет
window.onReCaptchaLoad = function () {
    widgetId = grecaptcha.render('recaptcha-container', {
        sitekey: window.gCaptchaKey,
        size: 'invisible',
        callback: gRecaptchaCallback,
    });
};
